import React, {useState, useEffect} from 'react';
import GoogleMapReact from 'google-map-react';
export default function Map(props) {
  useEffect(() => {
    if (state.apiReady && props.places.length > 1) {
      setRoute([], state.direction);
      setRoute(props.places, state.direction);
    }
    console.log("LOG ME");
  }, [props.places]);

  useEffect(() => {
    if (state.apiReady) {
        console.log(props.center);
        if(props.center){
            setMyposition((prevState) => ({
                ...prevState,
                center: props.center
              }));
        }
    }
  }, [props.center]);
  const [state, setState] = useState({
    apiReady: false,
    mapInstance: null,
    mapApi: null,
    direction: null
  });
  const [myposition, setMyposition] = useState({
    center: {
      lat: 13.545550016333902,
      lng: 100.96180662698616
    },
    zoom: 17
  });

  const chunks = (a, size) =>
    Array.from(new Array(Math.ceil(a.length / size)), (_, i) =>
      a.slice(i * size, i * size + size)
    );

  const setRoute = (places, direction) => {
    console.log("SET ROUTE");
    if (places.length > 1) {
      places = chunks(places, 25)[0];
      const directionsService = new google.maps.DirectionsService();
      let bounds = new google.maps.LatLngBounds();
      const waypoints = places.map((p, i) => {
        bounds.extend({
          lat: p.lat,
          lng: p.lng
        });

        return {location: {lat: p.lat, lng: p.lng}, stopover: true};
      });
      const origin = waypoints.shift().location;
      const destination = waypoints.pop().location;

      directionsService.route(
        {
          origin: origin,
          destination: destination,
          travelMode: google.maps.TravelMode.DRIVING,
          waypoints: waypoints
        },
        (result, status) => {
          if (status === google.maps.DirectionsStatus.OK) {
            direction.setDirections(result);
            var totalDistance = 0;
            var legs = result.routes[0].legs;
            for (var i = 0; i < legs.length; ++i) {
              totalDistance += legs[i].distance.value;
            }
            console.log(totalDistance);
            // setTimeout(() => {
            //   let zoom = 17;
            //   if (totalDistance < 3000) zoom = 15;
            //   if (totalDistance >= 3000 && totalDistance < 10000) zoom = 13;
            //   if (totalDistance >= 10000 && totalDistance < 30000) zoom = 12;
            //   if (totalDistance >= 30000 && totalDistance < 50000) zoom = 12;
            //   if (totalDistance >= 50000 && totalDistance < 100000) zoom = 10;
            //   if (totalDistance >= 100000) zoom = 9;

            //   // if (totalDistance )
            //   // _state.mapInstance.fitBounds(bounds);
            //   // _state.mapInstance.setZoom(zoom);
            //   // map.fitBounds(bounds);
            //   // map.setZoom(zoom);
            // }, 1000);
          } else {
            console.error(`error fetching directions ${result}`);
          }
        }
      );
    } 
    else {
        direction.setDirections({routes: []});
    }
  };

  const handleApiLoaded = (map, maps) => {
    if (map && maps) {
      const directionsRenderer = new google.maps.DirectionsRenderer();
      directionsRenderer.setMap(map);
      var mapOptions = {
        zoom: 17,
        styles: [
          {
            featureType: 'all',
            elementType: 'all',
            stylers: [
              {
                visibility: 'on'
              }
            ]
          }
        ]
      };
      map.setOptions(mapOptions);
      setState({
        apiReady: true,
        mapInstance: map,
        mapApi: maps,
        direction: directionsRenderer
      });
      setRoute([], directionsRenderer);
      setRoute(props.places, directionsRenderer);
    }
  };

  return (
    <GoogleMapReact
      bootstrapURLKeys={{
        // key: 'AIzaSyCRKtowMDI_bkZpeIcut4jDnuhDXbaMBG0',
        key: 'AIzaSyD2strutsAxeWXJwqDIE6Oq4EYGy5A6ji4',
        libraries: ['places', 'geometry']
      }}
      center={myposition.center}
      defaultZoom={myposition.zoom}
      yesIWantToUseGoogleMapApiInternals
      // onClick={onClick}
      onGoogleApiLoaded={({map, maps}) => handleApiLoaded(map, maps)}
    ></GoogleMapReact>
  );
}
